<template>
  <div id="app">
    <div
      id="playerContainer"
      :class="containerClass"
      class="player-container portrait plyr--video"
    >
      <Player ref="player" @canplay="handleCanplay" />
      <AdContainer v-if="adEnabled && canplay" />
    </div>
  </div>
</template>

<script>
import platform from 'platform'
import Player from './components/Player.vue'
import AdContainer from './components/AdContainer.vue'
import ga from './lib/ga'

ga.sendPageView(window.LVPS_ID)

const isMobile = () => {
  return ['iOS', 'Android'].includes(platform.os.family)
}

export default {
  name: 'App',
  components: {
    Player,
    AdContainer
  },
  data() {
    return {
      canplay: false,
      adEnabled: window.LVPS_AD_ENABLED === 1
    }
  },
  computed: {
    containerClass() {
      return {
        mobile: isMobile(),
        'ad-enabled': this.$data.adEnabled
      }
    }
  },
  methods: {
    handleCanplay() {
      this.$data.canplay = true
    }
  }
}
</script>

<style lang="sass">
.player-container
  position: relative
  overflow: visible
  &.mobile:fullscreen
    display: flex

.landscape
  &.player-container.ad-enabled
    padding-right: 300px
    padding-bottom: 105px

.plyr--video
  background-color: transparent
  &.plyr--fullscreen-fallback
    background-color: black

.plyr--fullscreen-fallback
  position: fixed
  padding-bottom: 0 !important
  top: 0
  left: 0
  display: flex
  align-items: center

  .ad-container-p-top
    position: absolute
    top: 0

  .ad-container-p-bottom
    position: absolute
    bottom: 0

  .ad-container-bottom
    position: absolute
    bottom: 0

  &.landscape
    #videoRoot
      align-self: start
</style>



// WEBPACK FOOTER //
// src/App.vue